import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation } from "react-query";

export type Position = "none" | "standing" | "sitting" | "lying";

export interface Vars {
  exerciseId: number;
  level: any;
  position: Position | null | undefined;
}

export const usePutLevelPosition = () =>
  useMutation((data: Vars) => {
    const position = data.position === "none" ? undefined : data.position;
    const { translations, image_url, video, ...levelData } = data.level;

    // @ts-ignore
    return api(`PUT /exercises/${data.exerciseId}/levels/${data.level.id}`, {
      root: supportApiBase,
      data: {
        ...levelData,
        position,
      },
    });
  });
